import { render, staticRenderFns } from "./ListItemChannel.vue?vue&type=template&id=d022eed8&scoped=true&"
import script from "./ListItemChannel.vue?vue&type=script&lang=js&"
export * from "./ListItemChannel.vue?vue&type=script&lang=js&"
import style0 from "./ListItemChannel.vue?vue&type=style&index=0&id=d022eed8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d022eed8",
  null
  
)

export default component.exports